import { parse } from 'qs';
import { useLocation } from 'react-router-dom';

export const useIsApp = () => {
  const location = useLocation();
  /**
   * NOTE: useSearchParamsを使わず意図的にqsでパースしています。
   * チケット: https://www.notion.so/funteractive/1d68b852b5d6805fa399cb00e08dac8f?pvs=4
   * 理由はURLSearchParamsがプラス記号をスペースに変換する仕様なので、アプリから送られるエンコードされたBase64文字列にプラス記号が含まれるとデータが壊れるため。（ref: https://developer.mozilla.org/ja/docs/Web/API/URLSearchParams#%E3%83%97%E3%83%A9%E3%82%B9%E8%A8%98%E5%8F%B7%E3%81%AE%E6%B8%A9%E5%AD%98）。
   * この問題を回避するためにクエリパラメータのパースをしつつデコード過程では何もしないという実装にするためにqsを用いています。
   */
  const searchParams = parse(location.search, {
    ignoreQueryPrefix: true,
    /**
     * ｑｓもデフォルトではプラス記号を温存しないためカスタムデコーダーで何もしないようにする
     */
    decoder: (str) => str,
  }) as { [key: string]: string | undefined };

  const identification = searchParams['identification'];
  const isApp = !!identification;

  return { isApp, identification };
};
